import UpdatePasswordForm from '@/components/UpdatePasswordForm';
import { MESSAGES } from '@/constants/messages';
import { UpdatePasswordFields } from '@/types/common';
import showToast from '@/utils/toast';
import {
  Dialog,
  DialogContent,
  Typography,
  Stack,
  DialogActions,
} from '@mui/material';
import { UseMutateAsyncFunction } from '@tanstack/react-query';
import { SVButton } from '../core';

type ResetPasswordModalProps = {
  userType: 'Staff' | 'Customer' | 'Teammate';
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  resetPassword: UseMutateAsyncFunction<
    unknown,
    Error,
    UpdatePasswordFields,
    unknown
  >;
  isResetPasswordLoading: boolean;
  scrollToTop: (behavior?: ScrollBehavior) => void;
};

export default function ResetPasswordModal({
  userType,
  open,
  setOpen,
  resetPassword,
  isResetPasswordLoading,
  scrollToTop,
}: ResetPasswordModalProps) {
  async function handleSubmit(data: UpdatePasswordFields) {
    try {
      resetPassword(data);
      showToast({
        type: 'success',
        data: { content: `${userType} password has been successfully updated` },
      });
      setOpen(false);
      scrollToTop();
    } catch {
      showToast({ type: 'error', data: { content: MESSAGES.genericError } });
    }
  }

  return (
    <Dialog fullWidth open={open} onClose={() => setOpen(false)}>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="h5" component="h1">
            Reset Password
          </Typography>
          <UpdatePasswordForm
            isLoading={isResetPasswordLoading}
            handleSubmit={handleSubmit}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <SVButton onClick={() => setOpen(false)} variant="tertiary">
          Back
        </SVButton>
      </DialogActions>
    </Dialog>
  );
}
